import { dew as _abisDew } from "../../constants/abis.js";
import { dew as _decodeFunctionResultDew } from "../../utils/abi/decodeFunctionResult.js";
import { dew as _encodeFunctionDataDew } from "../../utils/abi/encodeFunctionData.js";
import { dew as _getChainContractAddressDew } from "../../utils/chain/getChainContractAddress.js";
import { dew as _trimDew } from "../../utils/data/trim.js";
import { dew as _toHexDew } from "../../utils/encoding/toHex.js";
import { dew as _errorsDew } from "../../utils/ens/errors.js";
import { dew as _namehashDew } from "../../utils/ens/namehash.js";
import { dew as _packetToBytesDew } from "../../utils/ens/packetToBytes.js";
import { dew as _getActionDew } from "../../utils/getAction.js";
import { dew as _readContractDew } from "../public/readContract.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getEnsAddress = void 0;
  const abis_js_1 = _abisDew();
  const decodeFunctionResult_js_1 = _decodeFunctionResultDew();
  const encodeFunctionData_js_1 = _encodeFunctionDataDew();
  const getChainContractAddress_js_1 = _getChainContractAddressDew();
  const trim_js_1 = _trimDew();
  const toHex_js_1 = _toHexDew();
  const errors_js_1 = _errorsDew();
  const namehash_js_1 = _namehashDew();
  const packetToBytes_js_1 = _packetToBytesDew();
  const getAction_js_1 = _getActionDew();
  const readContract_js_1 = _readContractDew();
  async function getEnsAddress(client, {
    blockNumber,
    blockTag,
    coinType,
    name,
    universalResolverAddress: universalResolverAddress_
  }) {
    let universalResolverAddress = universalResolverAddress_;
    if (!universalResolverAddress) {
      if (!client.chain) throw new Error("client chain not configured. universalResolverAddress is required.");
      universalResolverAddress = (0, getChainContractAddress_js_1.getChainContractAddress)({
        blockNumber,
        chain: client.chain,
        contract: "ensUniversalResolver"
      });
    }
    try {
      const functionData = (0, encodeFunctionData_js_1.encodeFunctionData)({
        abi: abis_js_1.addressResolverAbi,
        functionName: "addr",
        ...(coinType != null ? {
          args: [(0, namehash_js_1.namehash)(name), BigInt(coinType)]
        } : {
          args: [(0, namehash_js_1.namehash)(name)]
        })
      });
      const res = await (0, getAction_js_1.getAction)(client, readContract_js_1.readContract, "readContract")({
        address: universalResolverAddress,
        abi: abis_js_1.universalResolverResolveAbi,
        functionName: "resolve",
        args: [(0, toHex_js_1.toHex)((0, packetToBytes_js_1.packetToBytes)(name)), functionData],
        blockNumber,
        blockTag
      });
      if (res[0] === "0x") return null;
      const address = (0, decodeFunctionResult_js_1.decodeFunctionResult)({
        abi: abis_js_1.addressResolverAbi,
        args: coinType != null ? [(0, namehash_js_1.namehash)(name), BigInt(coinType)] : undefined,
        functionName: "addr",
        data: res[0]
      });
      if (address === "0x") return null;
      if ((0, trim_js_1.trim)(address) === "0x00") return null;
      return address;
    } catch (err) {
      if ((0, errors_js_1.isNullUniversalResolverError)(err, "resolve")) return null;
      throw err;
    }
  }
  exports.getEnsAddress = getEnsAddress;
  //# sourceMappingURL=getEnsAddress.js.map
  return exports;
}